import { render, staticRenderFns } from "./product-order-indicator.vue?vue&type=template&id=0049acbb&scoped=true&"
import script from "./product-order-indicator.vue?vue&type=script&lang=ts&"
export * from "./product-order-indicator.vue?vue&type=script&lang=ts&"
import style0 from "./product-order-indicator.vue?vue&type=style&index=0&id=0049acbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0049acbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0049acbb')) {
      api.createRecord('0049acbb', component.options)
    } else {
      api.reload('0049acbb', component.options)
    }
    module.hot.accept("./product-order-indicator.vue?vue&type=template&id=0049acbb&scoped=true&", function () {
      api.rerender('0049acbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/products/components/product-order-indicator.vue"
export default component.exports